import { BackendResponse } from "../BackendResponse";
import { NextApiParams, withNextApi } from "../nextApiHelpers";

export interface RemoveExperienceFromCandidateResponse
  extends BackendResponse {}
export interface RemoveExperienceFromCandidateParameters extends NextApiParams {
  experienceId: number;
}

export const removeExperienceFromCandidate = withNextApi<
  RemoveExperienceFromCandidateResponse,
  RemoveExperienceFromCandidateParameters
>("/cvp/CvpRemoveExperienceFromCandidate");
